import { Link } from "react-router-dom";
import { SEGURANCA_INFANTIL } from "@nhomi/conteudo";
import { TopBar } from "@/ui/primitives";
import { TextoLongo } from "@/ui/TextoLongo";

/* Padrões de segurança infantil. Fora do Guard, como a privacidade: é a
   URL pública que vai no formulário da Play, e ela tem que abrir para
   quem não tem conta. O texto mora em `@nhomi/conteudo`. */

export function SegurancaInfantil() {
  return (
    <main className="screen">
      <TopBar title="Segurança infantil" back="/" />
      <div className="screen-body pad texto-longo selecionavel">
        <TextoLongo blocos={SEGURANCA_INFANTIL} />

        <p className="fine">
          <Link to="/privacidade">Política de privacidade</Link> · <Link to="/sobre">Sobre o Nhomi</Link>
        </p>
        <div className="gap" />
      </div>
    </main>
  );
}
